import { Component, EventEmitter, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SecurityService } from 'src/services/security/security.service';
import { ConfigPanelService } from '../../../layout/config-panel.service';
import { PLANNED } from '../../../../vex-core/navigation/navigation-menu.builder';
import { SidePanelsService } from 'src/app/shared/side-panels/side-panels.service';
import { isPlainClick } from 'src/app/shared/side-panels/side-panel-links';

@Component({
  selector: 'vex-sidenav-user-menu',
  templateUrl: './sidenav-user-menu.component.html',
  styleUrls: ['./sidenav-user-menu.component.scss'],
  imports: [RouterLink, MatIconModule, MatTooltipModule],
  standalone: true
})
/**
 * The account menu (name at the bottom of the side menu): a card drawn like the menu's other hover cards
 * (Dani, 02/10). The side menu hosts it in its own overlay and closes it when this emits `closed`.
 */
export class SidenavUserMenuComponent {
  /** Tooltips of the PLANNED rows (same words as the side menu's). */
  readonly planned = PLANNED;

  /** A row was used: the host closes the card. */
  @Output() readonly closed = new EventEmitter<void>();

  constructor(
    protected securityService: SecurityService,
    private configPanelService: ConfigPanelService,
    private sidePanels: SidePanelsService,
  ) { }

  /** "My profile": the reader's own person panel; a modified click keeps the link's new tab. */
  openMyProfile(event: MouseEvent): void {
    if (!isPlainClick(event)) return;
    event.preventDefault();
    const me = this.securityService.securityObject;
    this.sidePanels.openPerson(me.userId, {
      name: `${me.userFirstName ?? ''} ${me.userLastName ?? ''}`.trim(),
      photo: me.userPhoto,
      orgName: me.orgName,
      orgLogo: me.orgLogo,
    });
    this.close();
  }

  logout() {
    this.close();
    this.securityService.resetSecurityObject();
  }

  toggleConfigPanel() {
    this.configPanelService.toggleConfigPanel();
    this.close();
  }

  close(): void {
    this.closed.emit();
  }
}
